export default __webpack_public_path__ + "static/media/move-logo.eb7bd289.png";